import React from 'react';
import {Link} from 'react-router';
class RowItemSearchCongChucSoNoiVu extends React.Component {

  chonCongChuc() {
    this.props.onSelect(this.props.item);
  }

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.hoVaTen}</td>
        <td>
          <p>Email: {this.props.item.email}</p>
          <p>Đơn vị: {this.props.item.tenDonVi}</p>
          <p>Phòng: {this.props.item.tenPhong}</p>
        </td>
        <td>{this.props.item.tenTrangThai}</td>
        <td className="action-center">
            <Link className="icon-check-file" onClick={this.chonCongChuc.bind(this)}>Chọn</Link>
        </td>
      </tr>
    );
  }
}

export default RowItemSearchCongChucSoNoiVu;


// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemSearchCongChucSoNoiVu.jsx